import type { ElementType } from 'react';

import { ReadCareerHistory } from 'src/components/Profile/CareerHistory/ReadCareerHistory/ReadCareerHistory';
import { FinishResume } from 'src/components/Profile/CreateResume/FinishResume/FinishResume';
import { SimplePersonalDetails } from 'src/components/Profile/CreateResume/SimplePersonalDetails/SimplePersonalDetails';
import { ReadEducation } from 'src/components/Profile/Education/ReadEducation/ReadEducation';
import { ReadLanguages } from 'src/components/Profile/Languages/ReadLanguages';
import { ReadLicences } from 'src/components/Profile/Licences/ReadLicences/ReadLicences';
import { ReadNextRole } from 'src/components/Profile/NextRole/ReadNextRole/ReadNextRole';
import { ReadPersonalDetails } from 'src/components/Profile/PersonalDetails/ReadPersonalDetails/ReadPersonalDetails';
import { ProfileVisibilityContainer } from 'src/components/Profile/ProfileVisibility/ProfileVisibilityContainer';
import { ProfileVisibilityV2Container } from 'src/components/Profile/ProfileVisibilityV2/ProfileVisibilityV2Container';
import { ReadResume } from 'src/components/Profile/Resume/ReadResume/ReadResume';
import { ReadSkills } from 'src/components/Profile/Skills/ReadSkills/ReadSkills';
import { ReadSummary } from 'src/components/Profile/Summary/ReadSummary/ReadSummary';
import { Tips } from 'src/components/Profile/Tips/Tips';
import {
  SUMMARY,
  CAREER_HISTORY,
  RESUME,
  NEXT_ROLE,
  SKILLS,
  PERSONAL_DETAILS,
  PROFILE_INSIGHTS,
  PROFILE_VISIBILITY,
  PROFILE_VISIBILITY_V2,
  EDUCATION,
  PROFILE_PAGE,
  CREATE_RESUME_PAGE,
  TIPS,
  FINISH_RESUME,
  LICENCES,
  LANGUAGES,
  SHAREABLE_PROFILE_PAGE,
  SHAREABLE_PROFILE,
  SUGGESTIONS,
  VERIFICATIONS,
} from 'src/components/Router';
import type { Card, Page } from 'src/types';

import { ProfileInsights } from '../ProfileInsights/ProfileInsights';
import { ShareableProfileStatus } from '../ProfileVisibilityV2/ShareableProfileStatus/ShareableProfileStatus';
import { CareerHistory } from '../ShareableProfile/CareerHistory/CareerHistory';
import { Education } from '../ShareableProfile/Education/Education';
import { Languages } from '../ShareableProfile/Languages/Languages';
import { Licences } from '../ShareableProfile/Licences/Licences';
import { PersonalDetails } from '../ShareableProfile/PersonalDetails/PersonalDetails';
import { Skills } from '../ShareableProfile/Skills/Skills';
import { Summary } from '../ShareableProfile/Summary/Summary';
import { Suggestions } from '../Suggestions/Suggestions';
import { Verifications } from '../Verifications/Verifications';
type Cards = {
  [key in Page]: Record<string, ElementType>;
};

const cards: Cards = {
  [PROFILE_PAGE]: {
    [CAREER_HISTORY]: ReadCareerHistory,
    [EDUCATION]: ReadEducation,
    [LANGUAGES]: ReadLanguages,
    [LICENCES]: ReadLicences,
    [NEXT_ROLE]: ReadNextRole,
    [PERSONAL_DETAILS]: ReadPersonalDetails,
    [PROFILE_INSIGHTS]: ProfileInsights,
    [PROFILE_VISIBILITY]: ProfileVisibilityContainer,
    [PROFILE_VISIBILITY_V2]: ProfileVisibilityV2Container,
    [RESUME]: ReadResume,
    [SHAREABLE_PROFILE]: ShareableProfileStatus,
    [SKILLS]: ReadSkills,
    [SUGGESTIONS]: Suggestions,
    [SUMMARY]: ReadSummary,
    [TIPS]: Tips,
    [VERIFICATIONS]: Verifications,
  },
  [SHAREABLE_PROFILE_PAGE]: {
    [PERSONAL_DETAILS]: PersonalDetails,
    [SUMMARY]: Summary,
    [CAREER_HISTORY]: CareerHistory,
    [EDUCATION]: Education,
    [LICENCES]: Licences,
    [SKILLS]: Skills,
    [LANGUAGES]: Languages,
  },
  [CREATE_RESUME_PAGE]: {
    [PERSONAL_DETAILS]: SimplePersonalDetails,
    [SUMMARY]: ReadSummary,
    [CAREER_HISTORY]: ReadCareerHistory,
    [LICENCES]: ReadLicences,
    [SKILLS]: ReadSkills,
    [LANGUAGES]: ReadLanguages,
    [EDUCATION]: ReadEducation,
    [FINISH_RESUME]: FinishResume,
  },
};

export const getComponent = ({
  card,
  page = PROFILE_PAGE,
}: {
  card: Card;
  page?: Page;
}): ElementType => cards[page][card];
